import React from 'react';
import classNames from 'classnames';
import Loader from '../loader/Loader';
import './button.scss';

type ButtonProps = {
    authButton?: boolean;
    children?: React.ReactNode;
    clickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    extraClass?: string;
    isLoading?: boolean;
    name?: string;
    secondaryButton?: boolean;
    text?: string;
    token?: string;
    transparentButton?: boolean;
};

const Button = ({
    authButton,
    children,
    clickHandler,
    disabled = false,
    extraClass,
    isLoading = false,
    name,
    secondaryButton,
    text,
    token,
    transparentButton,
}: ButtonProps) => {
    const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        clickHandler(e);
    };

    const classes: Record<string, boolean> = {
        'b-button': true,
        'video-packager-field': true,
        'primary-button': !secondaryButton && !transparentButton,
        'secondary-button': !!secondaryButton,
        'transparent-button': !!transparentButton,
        hidden: typeof authButton !== 'undefined'
            && authButton && token === '',
    };

    if (typeof extraClass !== 'undefined') {
        classes[extraClass] = true;
    }

    const btnClass = classNames(classes);

    return (
        <button
            type='button'

            className={btnClass}
            disabled={disabled || isLoading}
            name={name}
            onClick={onClick}
            data-testid={`button-${name}`}
        >
            {isLoading && (
                <Loader isSmall isGrey />
            )}
            {children}
            {text}
        </button>
    );
};

export default Button;